export default __webpack_public_path__ + "static/media/2010.c1d36ae2.webp";